import { CURRENCY_SYMBOLS } from '@/lib/billing/billing';

export const SINGLE_PLAN = 'single';
export const TEAMS_PLAN = 'teams';
export const CUSTOM_PLAN = 'custom';

export type PlanType = 'single' | 'teams' | 'custom' | 'trial' | 'old';
export type OnlyNewPlanType = 'single' | 'teams' | 'custom';
export type PlanFrequencyType = 'monthly' | 'yearly';
export type CurrencyType = keyof typeof CURRENCY_SYMBOLS;
